import React from "react";
import { Fragment } from "react";

import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { TemplateOfferingListingDayPass } from "../template_offering_listing_daypass";
import { Text } from "../text";
import { faqsEN, faqsHE } from "./offering_wework_day_office";
import { useWeWorkAnalytics } from "./wework_analytics";
import { useWeWorkPartnerConfig } from "./wework_partner_config";

const Theme = lazyWithRetry(() => import("./wework_theme"));

export function OfferingWeWorkListingDailyAccess() {
  useWeWorkAnalytics();
  const { locale } = useI18n();
  const partnerConfig = useWeWorkPartnerConfig();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingDayPass
        showPrice={true}
        calculateLowestPrice={true}
        partnerConfig={{
          ...partnerConfig,
          title:
            locale.baseLanguageTag === "he"
              ? "גישה יומית ל-WeWork"
              : "Daily Access",
        }}
        data={{
          faqs: locale.baseLanguageTag === "he" ? faqsHE : faqsEN,
          description:
            locale.baseLanguageTag === "he" ? (
              <Container>
                <Text>
                  גישה יומית לחללי העבודה המשותפים במיקום ספציפי של WeWork, ללא
                  התחייבות. בין אם אתם זקוקים לחלל עבור עבודה פרודקטיבית, או חלל
                  מעורר השראה על מנת להניע פרויקט חדש, הגעתם למקום הנכון. אז איך
                  זה עובד? מזמינים מקום מראש, מגיעים לצ'ק אין זריז ומתחילים
                  לעבוד.
                </Text>
              </Container>
            ) : (
              <Container>
                <Text>
                  WeWork Daily Access provides you with a coworking space when
                  you need it, without a long term commitment. Whether you’re
                  tackling to-do’s or kicking off a project, you’ll have the
                  space, community, and amenities to work towards your goals.
                  Reserve your spot in advance, check-in, and get straight to
                  work.
                </Text>
              </Container>
            ),
        }}
      />
    </Fragment>
  );
}
